import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppLayout } from "@/components/AppLayout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Editor from "@/pages/Editor";
import History from "@/pages/History";
import Alignment from "@/pages/Alignment";
import ManageOptions from "@/pages/ManageOptions";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center app-canvas">
        <Loader2 className="h-6 w-6 animate-spin text-[#0284c7]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Editor /></Protected>} />
            <Route path="/history" element={<Protected><History /></Protected>} />
            <Route path="/alignment" element={<Protected><Alignment /></Protected>} />
            <Route path="/options" element={<Protected><ManageOptions /></Protected>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
